/**
 * Gatsby browser is loaded initially when your application loads.
 * This file can be considered as a pre-rendering file before executing your application.
 * This browser file should only have plain JS code
 */

import 'default-passive-events';
import { setPreviousPath } from 'helpers/back-button';

/**
 * Get browser name + version
 */
const getBrowser = () => {
	var ua = navigator.userAgent,
		tem,
		M = ua.match( /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i ) || [];

	if ( /trident/i.test( M[ 1 ] ) ) {
		tem = /\brv[ :]+(\d+)/g.exec( ua ) || [];
		return {
			name: 'IE',
			version: tem[ 1 ] || '',
		};
	}

	M = M[ 2 ] ? [ M[ 1 ], M[ 2 ] ] : [ navigator.appName, navigator.appVersion, '-?' ];

	if ( ( tem = ua.match( /version\/(\d+)/i ) ) != null ) {
		M.splice( 1, 1, tem[ 1 ] );
	}

	return {
		name: M[ 0 ],
		version: M[ 1 ],
	};
};

if ( typeof window !== 'undefined' ) {
	const browser = getBrowser();

	// If user is having IE browser then we redirect to IE Edge
	if ( browser.name === 'IE' || browser.name === 'ie' ) {
		window.open( 'microsoft-edge:' + window.location.href );
	}
}

/**
 * onRouteUpdate API is part of Gatsby’s browser APIs, specifically designed for handling route updates in a Gatsby.
 *
 * @param {Object} location - Location object of current page provided by Gastby API.
 * @param {Object} prevLocation - Location object of previous page provided by Gatsby API.
 * @returns {void}
 */
export const onRouteUpdate = ( { location, prevLocation } ) => {
	setPreviousPath( prevLocation ? prevLocation.href : null );
};
